import { render, staticRenderFns } from "./PicPreviewer.vue?vue&type=template&id=45b70db8"
import script from "./PicPreviewer.vue?vue&type=script&lang=js"
export * from "./PicPreviewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports